import React, {useContext, useEffect} from 'react';

import {useFormikContext} from "formik";

import Grid from "@mui/material/Grid";

import ContractNumberField from "./ContractNumberField";
import WsPasswordField from "./WsPasswordField";

import {ShippingMethodFormContext} from "../../../context/ShippingMethodFormContext";

function ApiFields(props) {
    const {isApi} = useContext(ShippingMethodFormContext);

    const {validateField} = useFormikContext()

    // trigger validation of api fields
    useEffect(() => {
        validateField('contractNumber');
        validateField('wsPassword');
    }, [isApi]);

    if (!isApi) {
        return null;
    }

    return (
        <Grid item container rowSpacing={2}>
            <Grid item container columnSpacing={2}>
                <Grid item xs={6}>
                    <ContractNumberField />
                </Grid>
                <Grid item xs={6}>
                    <WsPasswordField />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default ApiFields;
